<template>
	<div class="treatments">
		<v-container tag="section" fluid constrain>
			<v-sheet :class="[$vuetify.breakpoint.mdAndUp ? 'pa-12' : 'pa-6']">
				<v-row no-gutters>
					<v-col cols="12" md="5" :pr-12="$vuetify.breakpoint.mdAndUp">
						<icon-title :src="icon" :width="$vuetify.breakpoint.mdAndUp ? 250 : 150" :size="$vuetify.breakpoint.mdAndUp ? '3rem' : '2rem'" :iconVisible="$vuetify.breakpoint.smAndUp">
							Behandlinger
						</icon-title>

						<p :class="[$vuetify.breakpoint.mdAndUp && 'pr-12']">
							Liste over de mest populære behandlingene hos salongene på fixit.no. Hvis du ikke finner din behandling her, søk på forsiden til
							<router-link style="color:grey; text-decoration:none" to="/">Fixit.no</router-link>
						</p>
					</v-col>
					<transition name="scroll-y-transition" mode="out-in">
						<v-col cols="12" md="7" class="primary--text headline font-weight-bold">
							<v-row>
								<v-col
									cols="6"
									xs="6"
									sm="4"
									md="4"
									v-for="treatment in filteredTreatments"
									:key="treatment.fixitTreatmentId ? `treatment-${treatment.fixitTreatmentId}` : `treatment-category-${treatment.fixitCategoryId}`"
								>
									<TreatmentCardContainer :treatment="treatment" :url="`/behandlinger/${treatment.url}`"></TreatmentCardContainer>
								</v-col>
							</v-row>
						</v-col>
					</transition>
				</v-row>
			</v-sheet>
		</v-container>
	</div>
</template>

<script>
import IconTitle from '@/components/IconTitle';
import TreatmentCardContainer from './TreatmentCardContainer';

export default {
	name: 'treatment-page',
	components: {
		IconTitle,
		TreatmentCardContainer
	},
	data() {
		return {
			treatments: [],
			icon: require('@/assets/img/scissor-icon.png')
		};
	},
	computed: {
		filteredTreatments() {
			let show = this.treatmentCategories.filter(function(t) {
				if (t.showLandingPageForMainAreas || t.showLandingPageForAllAreas) {
					return true;
				}
				if (!t.treatments) {
					return false;
				}
				var sub = t.treatments.filter(function(sub) {
					return sub.showLandingPageForMainAreas || sub.showLandingPageForAllAreas;
				});
				return sub.length;
			});

			return show;
		},

		treatmentCategories() {
			return this.$store.getters['treatment/treatments'];
		}
	},
	watch: {
		treatmentCategories: {
			handler(treatmentCategories) {
				if (!treatmentCategories || !treatmentCategories.length) {
					this.$store.dispatch('treatment/getTreatments');
				}
			},
			immediate: true
		}
	}
};
</script>

<style scoped></style>
